module.exports = __webpack_public_path__ + "static/media/national-2-web-regular.8dd40a95.eot";